/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
// Fix for mobile filter toggle
document.addEventListener('DOMContentLoaded', function() {
  const filterToggle = document.querySelector('[aria-controls="filter-groups"]');
  const filterSidebar = document.getElementById('filter-groups');

  if (filterToggle && filterSidebar) {
    filterToggle.addEventListener('click', function(e) {
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !isExpanded);
      filterSidebar.classList.toggle('expanded', !isExpanded);
    });
  }
});
  

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
